import React, { useEffect, createElement } from 'react';
import { Landing } from './pages/Landing';
const META_PIXEL_ID = '1643729186685202';
const CLARITY_ID = 'xcupjj5n9x';
function initClarity() {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.clarity) return;
  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] = c[a] || function () {
      ;
      (c[a].q = c[a].q || []).push(arguments);
    };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    if (y && y.parentNode) {
      y.parentNode.insertBefore(t, y);
    } else {
      ;
      (l.head || l.documentElement).appendChild(t);
    }
  })(w, document, 'clarity', 'script', CLARITY_ID);
}
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) return;
  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      ;
      (b.head || b.documentElement).appendChild(t);
    }
  })(w, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  w.fbq('init', META_PIXEL_ID);
  w.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    initClarity();
  }, []);
  return <Landing data-id="element-0" />;
}